



































































































































































































































































































































import Component from "vue-class-component";
import { BTooltip } from "bootstrap-vue";

import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";
import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import EventBus from "@/utils/event-bus";
import Notification from "@/components/Notification.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import { SETTINGS_CHANGED } from "@/utils/constants";

@Component({
  components: {
    Notification,
    LoadingIndicator,
    BTooltip
  }
})
export default class Settings extends BaseRootPageComponent {
  loading = true;
  pbType = "ps";
  bsType = "ps";
  vbType = "ps";
  settings: any = {};
  success = "";
  error = "";

  get mobileSessionTimeoutInHours(): string {
    if (!this.settings?.mobileSessionTimeout) return "";

    // If for some reason an even hour wasn't entered, round to the nearest hour
    return Math.round(this.settings.mobileSessionTimeout / 60.0) + "";
  }

  set mobileSessionTimeoutInHours(value: string) {
    const val = Number.parseInt(value, 10);

    if (Number.isNaN(val)) {
      // If a number isn't valid, just store an empty string in the settings object so trying to save won't work since
      // this field is required.
      this.settings.mobileSessionTimeout = "";
    } else {
      this.settings.mobileSessionTimeout = Math.round(val * 60);
    }
  }

  async created() {
    this.setTitle("Settings");
    await this.fetchSettings();
  }

  resetError() {
    this.error = "";
  }

  resetSuccess() {
    this.success = "";
  }

  async fetchSettings() {
    try {
      this.loading = true;
      this.settings = await CoreAPI.getSettings();

      if (this.settings.patientBarcodeRegex) {
        this.pbType = "regex";
      }
      if (this.settings.scannerBarcodeRegex) {
        this.bsType = "regex";
      }
      if (this.settings.ventilatorBarcodeRegex) {
        this.vbType = "regex";
      }
    } catch (error) {
      this.error = "Failed to load settings";

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      }
    } finally {
      this.loading = false;
    }
  }

  async saveSettings() {
    // convert text to number
    const webSessionTimeout = parseInt(this.settings.webSessionTimeout, 10);
    const mobileSessionTimeout = parseInt(this.settings.mobileSessionTimeout, 10);
    const disassociationTimeout = parseInt(this.settings.disassociationTimeout, 10);
    const workflowTimeout = parseInt(this.settings.workflowTimeout, 10);
    const scannerSensitivity = parseInt(this.settings.scannerSensitivity, 10);
    const autoSubmitIdleTimeout = parseInt(this.settings.autoSubmitIdleTimeout, 10);
    const autoSubmitChars = parseInt(this.settings.autoSubmitChars, 10);
    const autoSubmitEnabled = this.settings.autoSubmitEnabled;
    if (
      !Number.isInteger(webSessionTimeout) ||
      !Number.isInteger(mobileSessionTimeout) ||
      !Number.isInteger(disassociationTimeout) ||
      !Number.isInteger(workflowTimeout) ||
      !Number.isInteger(scannerSensitivity) ||
      webSessionTimeout <= 0 ||
      mobileSessionTimeout <= 0 ||
      disassociationTimeout <= 0 ||
      workflowTimeout <= 0 ||
      scannerSensitivity <= 0 ||
      (autoSubmitEnabled &&
        (!Number.isInteger(autoSubmitIdleTimeout) ||
          autoSubmitIdleTimeout <= 0 ||
          !Number.isInteger(autoSubmitChars) ||
          autoSubmitChars <= 0))
    ) {
      this.success = "";
      this.error = "Invalid input values";
      return;
    }
    if (this.pbType === "ps") {
      this.settings.patientBarcodeRegex = "";
    } else {
      this.settings.patientBarcodePrefix = "";
      this.settings.patientBarcodeSuffix = "";
    }
    if (this.bsType === "ps") {
      this.settings.scannerBarcodeRegex = "";
    } else {
      this.settings.scannerBarcodePrefix = "";
      this.settings.scannerBarcodeSuffix = "";
    }
    if (this.vbType === "ps") {
      this.settings.ventilatorBarcodeRegex = "";
    } else {
      this.settings.ventilatorBarcodePrefix = "";
      this.settings.ventilatorBarcodeSuffix = "";
    }
    const settings = Object.assign({}, this.settings, {
      webSessionTimeout,
      mobileSessionTimeout,
      disassociationTimeout,
      workflowTimeout,
      scannerSensitivity,
      autoSubmitEnabled,
      autoSubmitChars,
      autoSubmitIdleTimeout
    });

    try {
      await CoreAPI.updateSettings(settings);
      this.success = "Settings saved";
      this.error = "";

      EventBus.$emit(SETTINGS_CHANGED);
    } catch (error) {
      this.success = "";
      this.error = "Failed to save settings";

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      }
    }
  }

  cancel() {
    this.$router.push(this.routes[0].path);
  }
}
